<template>
  <v-dialog v-model="dialog" persistent width="401">
    <common-card>
      <v-card-text class="pa-4 black--text" style="text-align: center;">
        <div
          class="pt-5 pb-5 top-text"
          style="width: 100%; height: 100%; justify-content: center;"
        >
          Liberando lead
        </div>
        <div style="justify-items: center;">
          <v-img
            class="responsive"
            contain
            max-height="200"
            max-width="300"
            :src="loader.createAccount"
          ></v-img>
        </div>
        <div class="pt-5 pb-5">
          <span class="confirmation-text">
            Espere un momento el lead se esta actualizando...
          </span>
        </div>
      </v-card-text>
    </common-card>
  </v-dialog>
</template>

<script>
import CommonCard from "./CommonCard.vue";
import loginData from "@/helpers/data/data-login-template.json";

export default {
  components: {
    CommonCard,
  },
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    uuid: {
      type: String,
      default: "",
    },
  },

  data() {
    return {
      loader: loginData,
    };
  },
  methods: {
    userChoice(val) {
      this.$emit("userChoice", val);
    },
  },
};
</script>

<style>
.v-toolbar--dense .v-toolbar__content,
.v-toolbar--dense .v-toolbar__extension {
  padding-top: 0;
  padding-bottom: 0;
  justify-content: center;
}

.top-text {
  width: 369px;
  height: 22px;
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 110%;
  display: flex;
  align-items: center;
  text-align: center;
  color: #4d5358;
  flex: none;
  order: 0;
  flex-grow: 1;
}

.confirmation-text {
  /* Por favor, asegúrate de revisar cuidadosamente los cambios antes de continuar */

  width: 369px;
  height: 30px;

  /* Subtitle/S */
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 110%;
  /* or 15px */
  text-align: center;

  color: #555555;

  /* Inside auto layout */
  flex: none;
  order: 2;
  align-self: stretch;
  flex-grow: 0;
}
</style>
